module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-3-05883755162bf5ccd8819a8922446f65.svg";